import { ENV } from "../config/env";
import { type Post } from "../types/post.types";

export const getPosts =
  async (): Promise<Post[]> => {

    const response = await fetch(
      `${ENV.POST_API}/posts`
    );

    return response.json();
};